import {Component, HostListener, OnDestroy, OnInit} from '@angular/core';
import {ComponentAsElement} from '../../services/common/bootstrap/annotation/component-as-element';
import {CommonModalTemplatesEnum, CommonModalTemplatesInterfaces} from '../modals/all-modals-config';
import {CommonModalService} from './common-modal.service';
declare const window: any;

@ComponentAsElement('v-common-modal-element')
@Component({
  selector: 'v-common-modal',
  templateUrl: './common-modal.component.html',
  styleUrls: []
})
export class CommonModalComponent {
  constructor(
    public commonModalService: CommonModalService,
  ) {
  }
  readonly PAGE_COVERING_CLASS_NAME = 'NG-covering';

  public readonly CommonModalTemplatesEnum: typeof CommonModalTemplatesEnum = CommonModalTemplatesEnum;

  @HostListener('click', ['$event'])
  detectedClickOnElement(_$event: MouseEvent) {
    const tagNames: Array<string> = ['A'];
    const target = _$event.target as HTMLElement;

    const isClickingOnAllowedTags = tagNames.indexOf(target.tagName) + 1;
    const isClickingOnPageCovering = target.className.trim().split(' ').indexOf(this.PAGE_COVERING_CLASS_NAME) + 1;

    const blockClick: boolean = !(isClickingOnAllowedTags || isClickingOnPageCovering);

    if (blockClick) {
      _$event.stopPropagation();
      _$event.preventDefault();
    }
  }

  @HostListener('document:click', ['$event'])
  detectedClickOutOfElement(_$event: MouseEvent) {
    if (!this.commonModalService.showModal || this.commonModalService.disableClose) {
      return;
    }

    const tagNames: Array<string> = ['A'];
    // @ts-ignore
    const paths = (_$event.path || _$event.composedPath()) as Array<HTMLElement>;
    const tagName = paths[0].tagName;

    const isClickingOnAllowedTags = tagNames.indexOf(tagName) + 1;

    if (!isClickingOnAllowedTags) {
      this.closeModal();
    }
  }

  public closeModal() {
    this.commonModalService.closeAllModals();
    if(window.dittoScan) {
      window.dittoScan.destroy();
    }
  }
}
